var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"inputFile",attrs:{"type":"file"},on:{"change":_vm.importExcel}}),_c('el-button',{attrs:{"icon":"el-icon-upload2","type":"warning"},on:{"click":_vm.onDerive}},[_vm._v("Import")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }